var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        attrs: {
          title: "Emisión por lotes",
          dense: true,
          breadcrumbs: _vm.breadcrumbs,
          hiddenTab: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c(
                  "v-btn",
                  {
                    attrs: { outlined: "" },
                    on: {
                      click: function ($event) {
                        _vm.dialogDetail = true
                      },
                    },
                  },
                  [_vm._v("Ver detalles")]
                ),
                _vm.documentsList.length
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "ml-2",
                        attrs: {
                          to: {
                            name: "DocumentsList",
                            query: { batch_id: _vm.instance.batch_id },
                            params: { ..._vm.$route.params },
                          },
                          outlined: "",
                        },
                      },
                      [_vm._v("Ir a documentos")]
                    )
                  : _vm._e(),
                _c(
                  "v-btn",
                  {
                    staticClass: "mx-2",
                    attrs: { outlined: "" },
                    on: { click: _vm.retrieve },
                  },
                  [
                    _c("v-img", {
                      attrs: {
                        contain: "",
                        src: require(`@/assets/icon-update${
                          _vm.$vuetify.theme.dark ? "-dark" : ""
                        }.svg`),
                      },
                    }),
                  ],
                  1
                ),
                ["PEN"].includes(_vm.instance.status) &&
                _vm.$helpers.hasSomePermission(["delete_batch"])
                  ? _c(
                      "v-btn",
                      {
                        attrs: { outlined: "" },
                        on: {
                          click: function ($event) {
                            _vm.dialogDelete = true
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { left: "" } }, [
                          _vm._v("mdi-login-variant"),
                        ]),
                        _vm._v("Interrumpir proceso"),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.loading && !_vm.loadingNextStage
        ? _c(
            "v-col",
            { staticClass: "mt-20 px-0", attrs: { cols: "12" } },
            [
              _c("v-skeleton-loader", {
                staticClass: "rounded-t-md",
                attrs: { transition: "fade-transition", type: "card-heading" },
              }),
              _c("v-skeleton-loader", {
                staticClass: "rounded-0",
                attrs: { transition: "fade-transition", type: "image" },
              }),
              _c("v-skeleton-loader", {
                staticClass: "rounded-b-md",
                attrs: { transition: "fade-transition", type: "table-tbody" },
              }),
            ],
            1
          )
        : _c(
            "v-col",
            { staticClass: "mt-20 px-0", attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "text-center mx-auto pa-0 pb-4 pt-8",
                      staticStyle: { "min-width": "800px" },
                      attrs: { cols: "11" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex justify-center",
                          class: {
                            "pb-4": !["PEN"].includes(_vm.instance.status),
                          },
                        },
                        _vm._l(_vm.currentStepper, function (step, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "text-center" },
                            [
                              _c(
                                "v-sheet",
                                {
                                  staticClass: "transparent",
                                  staticStyle: {
                                    "z-index": "0",
                                    position: "relative",
                                  },
                                  attrs: { "min-width": "110" },
                                },
                                [
                                  _c(
                                    "v-avatar",
                                    {
                                      style: _vm.stepStyle(step, index),
                                      attrs: { size: "30" },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: _vm.stepIconColor(
                                              step,
                                              index
                                            ),
                                            size: "15",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "mdi-" + _vm._s(step.icon) + " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-block mt-1 grey-500--text body-1 pt-1",
                                    },
                                    [_vm._v(_vm._s(step.title))]
                                  ),
                                ],
                                1
                              ),
                              _vm.stepperList.length - 1 !== index &&
                              index >= 0 &&
                              index <
                                _vm.currentStepper.findIndex((item) =>
                                  item.status.includes(_vm.instance.status)
                                )
                                ? _c("v-divider", {
                                    staticClass: "line-stepper",
                                    staticStyle: {
                                      border:
                                        "1px solid var(--light-green-500)",
                                    },
                                  })
                                : _vm.currentStepper.length - 1 !== index
                                ? _c("v-divider", {
                                    staticClass: "line-stepper",
                                    staticStyle: {
                                      border: "1px solid var(--light-grey-50)",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm.$helpers.hasSomePermission(["add_batch"])
                        ? [
                            ["PEN"].includes(_vm.instance.status)
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass:
                                      "mx-auto mt-4 subtitle-2 font-weight-medium",
                                    attrs: {
                                      text: "",
                                      color: "grey-900",
                                      ripple: false,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.dialogProcess = true
                                      },
                                    },
                                  },
                                  [_vm._v("Confirmar documentos")]
                                )
                              : _vm._e(),
                            ["COM"].includes(_vm.instance.status)
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass:
                                      "mx-auto mt-4 subtitle-2 font-weight-medium",
                                    attrs: {
                                      text: "",
                                      color: "grey-900",
                                      ripple: false,
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.dialogProcess = true
                                      },
                                    },
                                  },
                                  [_vm._v("Distribuir")]
                                )
                              : _vm._e(),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "v-card",
                {
                  class: [{ transparent: _vm.documentsList.length }, "mt-4"],
                  attrs: { flat: "" },
                },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "pa-0" },
                    [
                      _c(
                        "v-row",
                        { attrs: { "no-gutters": "" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "pa-0 pt-2",
                              class: { "pb-2": !_vm.documentsList.length },
                              attrs: { cols: "12" },
                            },
                            [
                              _vm.loadingBatchDocument
                                ? _c("skeleton-list")
                                : [
                                    !_vm.documentsList.length
                                      ? _c("v-empty-state", {
                                          staticClass: "mt-10",
                                          attrs: {
                                            type: "documents",
                                            id: "documentos",
                                            isFree: true,
                                            customClass: "mt-1",
                                            title:
                                              "No existen documentos para mostrar",
                                            height: 170,
                                            minHeight: "260px",
                                          },
                                        })
                                      : [
                                          _c("v-data-table", {
                                            class: [
                                              {
                                                "fixed-table":
                                                  _vm.$store.state.base
                                                    .isExpandNavigationDrawer,
                                              },
                                              "mt-n2",
                                            ],
                                            staticStyle: { cursor: "pointer" },
                                            attrs: {
                                              headers: _vm.currentHeader,
                                              items: _vm.documentsList,
                                              "items-per-page": _vm.pagination,
                                              "hide-default-header": "",
                                              "disable-sort": "",
                                              "item-key": "id",
                                              "hide-default-footer": "",
                                              "mobile-breakpoint": "300",
                                              height: _vm.heightTable,
                                              "fixed-header": "",
                                            },
                                            on: {
                                              "click:row": (documentsList) =>
                                                _vm.goTo(documentsList.id),
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "header",
                                                  fn: function ({
                                                    props: { headers },
                                                  }) {
                                                    return [
                                                      _c("VTableHeaders", {
                                                        attrs: {
                                                          headers: headers,
                                                        },
                                                      }),
                                                      _c("v-divider", {
                                                        staticStyle: {
                                                          position: "absolute",
                                                          "z-index": "2",
                                                          "margin-top": "-6px",
                                                          "margin-left": "-5px",
                                                          "min-width": "100%",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: `item.customer_name`,
                                                  fn: function ({ item }) {
                                                    return [
                                                      _c(
                                                        "router-link",
                                                        {
                                                          staticClass:
                                                            "grey-700--text text-decoration-none",
                                                          attrs: {
                                                            to: {
                                                              name: "DocumentsRetrieve",
                                                              params: {
                                                                ..._vm.$route
                                                                  .params,
                                                                id: item.id,
                                                              },
                                                            },
                                                          },
                                                        },
                                                        [
                                                          item.customer_name
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "d-inline-block text-truncate body-2",
                                                                  staticStyle: {
                                                                    "max-width":
                                                                      "100%",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.customer_name
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "body-2 text--disabled font-italic",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Sin especificar"
                                                                  ),
                                                                ]
                                                              ),
                                                          item.customer_tax_id
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "caption grey-300--text d-block",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "generals.RUT"
                                                                      )
                                                                    ) +
                                                                      " " +
                                                                      _vm._s(
                                                                        item?.customer_tax_id
                                                                      )
                                                                  ),
                                                                ]
                                                              )
                                                            : _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "body-2 text--disabled font-italic",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Sin especificar"
                                                                  ),
                                                                ]
                                                              ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: `item.type`,
                                                  fn: function ({ item }) {
                                                    return [
                                                      _vm.$route.name ===
                                                      "DocumentsBatchRetrieve"
                                                        ? _c(
                                                            "router-link",
                                                            {
                                                              staticClass:
                                                                "grey-700--text text-decoration-none",
                                                              attrs: {
                                                                to: {
                                                                  name: "DocumentsRetrieve",
                                                                  params: {
                                                                    ..._vm
                                                                      .$route
                                                                      .params,
                                                                    id: item.id,
                                                                  },
                                                                },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "body-2",
                                                                  staticStyle: {
                                                                    "white-space":
                                                                      "normal !important",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "nameDocumentsType"
                                                                      )(
                                                                        item.type
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "router-link",
                                                            {
                                                              staticClass:
                                                                "grey-700--text text-decoration-none",
                                                              attrs: {
                                                                to: {
                                                                  name: "DocumentsRetrieve",
                                                                  params: {
                                                                    ..._vm
                                                                      .$route
                                                                      .params,
                                                                    id: item.id,
                                                                  },
                                                                },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "body-2",
                                                                  staticStyle: {
                                                                    "white-space":
                                                                      "normal !important",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "nameDocumentsType"
                                                                      )(
                                                                        item.type
                                                                      )
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: `item.number`,
                                                  fn: function ({ item }) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "body-2",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(item.number)
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: `item.date`,
                                                  fn: function ({ item }) {
                                                    return [
                                                      _vm.$store?.state?.auth
                                                        ?.account?.country !==
                                                      "PE"
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "body-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "date"
                                                                  )(item.date)
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "body-2",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "dateTimeSecond"
                                                                  )(item.date)
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: `item.status`,
                                                  fn: function ({ item }) {
                                                    return [
                                                      _c("chip-status", {
                                                        attrs: {
                                                          status: item.status
                                                            ? item.status
                                                            : "CRE",
                                                          detail:
                                                            item?.agency_status_detail_list ||
                                                            item?.agency_status_info
                                                              ? `${
                                                                  _vm.setTooltip(
                                                                    item.agency_status_detail_list
                                                                  ) ||
                                                                  item.agency_status_info
                                                                }`
                                                              : null,
                                                          isTooltip: true,
                                                          isActivePopover: true,
                                                          type: "documents",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: `item.amount_total`,
                                                  fn: function ({ item }) {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "body-2",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$fmt.currency(
                                                                item?.currency ||
                                                                  _vm.$store
                                                                    ?.state
                                                                    ?.auth
                                                                    ?.account
                                                                    ?.currency,
                                                                item.amount_total
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                                {
                                                  key: `item.actions`,
                                                  fn: function ({ item }) {
                                                    return [
                                                      _c(
                                                        "v-menu",
                                                        {
                                                          attrs: {
                                                            "close-on-click":
                                                              "",
                                                            "close-on-content-click":
                                                              "",
                                                            "offset-y": "",
                                                            left: "",
                                                            "nudge-left": 10,
                                                            "nudge-bottom": 10,
                                                            transition:
                                                              "slide-y-transition",
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function ({
                                                                  on,
                                                                  attrs,
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "v-btn",
                                                                      _vm._g(
                                                                        _vm._b(
                                                                          {
                                                                            staticClass:
                                                                              "mr-n4",
                                                                            attrs:
                                                                              {
                                                                                text: "",
                                                                                "x-small":
                                                                                  "",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  _vm.current =
                                                                                    item
                                                                                },
                                                                            },
                                                                          },
                                                                          "v-btn",
                                                                          attrs,
                                                                          false
                                                                        ),
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "grey-500",
                                                                                size: "24",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-dots-vertical"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                        },
                                                        [
                                                          _c(
                                                            "v-list",
                                                            {
                                                              staticClass:
                                                                "pa-0",
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item",
                                                                {
                                                                  staticClass:
                                                                    "px-3",
                                                                  attrs: {
                                                                    ripple: false,
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        _vm.renderDocument2(
                                                                          "documents",
                                                                          null,
                                                                          "pdf",
                                                                          item.id
                                                                        ),
                                                                          (_vm.resetPDF += 1)
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    {
                                                                      staticClass:
                                                                        "body-2 grey-500--text d-flex align-center",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              color:
                                                                                "grey-700",
                                                                              size: "20",
                                                                              left: "",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-text-box"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        "Ver PDF"
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-list-item",
                                                                {
                                                                  staticClass:
                                                                    "px-3",
                                                                  attrs: {
                                                                    ripple: false,
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.downloadFile2(
                                                                          "documents",
                                                                          `${item.type}_${item.number}`,
                                                                          null,
                                                                          "xml",
                                                                          item.id
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-list-item-title",
                                                                    {
                                                                      staticClass:
                                                                        "body-2 grey-500--text d-flex align-center",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-icon",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              color:
                                                                                "grey-700",
                                                                              size: "20",
                                                                              left: "",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-code-braces-box"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        "Descargar documento"
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              [
                                                                "APR",
                                                                "OBS",
                                                              ].includes(
                                                                item.status
                                                              ) &&
                                                              _vm.$store?.state
                                                                ?.auth?.account
                                                                ?.country ===
                                                                "PE"
                                                                ? _c(
                                                                    "v-list-item",
                                                                    {
                                                                      staticClass:
                                                                        "px-3",
                                                                      attrs: {
                                                                        ripple: false,
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.downloadFile2(
                                                                              "documents",
                                                                              `${item.type}_${item.number}`,
                                                                              null,
                                                                              "voucher",
                                                                              item.id
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item-title",
                                                                        {
                                                                          staticClass:
                                                                            "body-2 grey-500--text d-flex align-center",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  color:
                                                                                    "grey-700",
                                                                                  size: "20",
                                                                                  left: "",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "mdi-code-braces-box"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            "Descargar CDR"
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          [
                                            _c("v-divider"),
                                            _c("VMainPagination", {
                                              attrs: {
                                                count: _vm.countDocuments,
                                                redirect: "DocumentsList",
                                              },
                                              on: {
                                                isActive:
                                                  _vm.getDocumentByBatch,
                                              },
                                            }),
                                          ],
                                        ],
                                  ],
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "650",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogProcess,
            callback: function ($$v) {
              _vm.dialogProcess = $$v
            },
            expression: "dialogProcess",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "transparent", flat: "", height: "46" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.modalConfirmData[_vm.instance.status]?.title
                            )
                          ),
                        ]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      ;(_vm.dialogProcess = false),
                                        (_vm.confirm = "")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-4 px-5 grey-500--text" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-2 pb-2", attrs: { align: "center" } },
                    [
                      _c("v-col", { attrs: { cols: "3" } }, [
                        _c("img", {
                          attrs: {
                            src: require(`@/assets/backgrounds/modal-document-confirm.svg`),
                            height: 128,
                          },
                        }),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "pr-3 pl-1" },
                        [
                          _c("span", {
                            staticClass: "d-block text-body-1",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.modalConfirmData[
                                  _vm.instance.status
                                ]?.description?.call(this)
                              ),
                            },
                          }),
                          _c(
                            "span",
                            { staticClass: "d-block text-body-1 mt-4 mb-3" },
                            [
                              _vm._v("Escribe "),
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("“confirmar”"),
                              ]),
                              _vm._v(" para continuar."),
                            ]
                          ),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              "single-line": "",
                              maxlength: "9",
                              dense: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.confirm,
                              callback: function ($$v) {
                                _vm.confirm = $$v
                              },
                              expression: "confirm",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          ;(_vm.dialogProcess = false), (_vm.confirm = "")
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        disabled: _vm.confirm.toLowerCase() !== "confirmar",
                      },
                      on: { click: _vm.handleConfirm },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.modalConfirmData[_vm.instance.status]?.titleBtn
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "700", persistent: "", "no-click-animation": "" },
          model: {
            value: _vm.dialogRandomReviewPDF,
            callback: function ($$v) {
              _vm.dialogRandomReviewPDF = $$v
            },
            expression: "dialogRandomReviewPDF",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { "min-height": "733" } },
            [
              [
                _c(
                  "v-toolbar",
                  { attrs: { color: "transparent", flat: "", height: "46" } },
                  [
                    _c(
                      "v-toolbar-title",
                      {
                        staticClass:
                          "px-5 subtitle-2 grey-500--text font-weight-semibold",
                      },
                      [_vm._v("Revisión aleatoria")]
                    ),
                    _c("v-spacer"),
                    _c(
                      "v-toolbar-items",
                      [
                        _c(
                          "v-row",
                          {
                            staticClass: "mr-3",
                            attrs: { align: "center", justify: "center" },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  icon: "",
                                  small: "",
                                  "retain-focus-on-click": "",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.dialogRandomReviewPDF = false
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { color: "grey-500", size: "20" } },
                                  [_vm._v("mdi-close")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("v-divider"),
              ],
              _c(
                "v-card-text",
                {
                  staticClass: "pa-0",
                  staticStyle: { "min-height": "635px !important" },
                },
                [
                  _c(
                    "v-alert",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.loaderRender && _vm.renderUrl,
                          expression: "!loaderRender && renderUrl",
                        },
                      ],
                      staticClass: "body-2 pl-5 inf-alert green-500--text",
                      attrs: {
                        height: 34,
                        dense: "",
                        text: "",
                        outlined: "",
                        color: "#BED2F0",
                        tile: "",
                      },
                    },
                    [
                      _vm._v(
                        "Esta visualización es una vista previa del documento, por lo que no es válido legalmente."
                      ),
                    ]
                  ),
                  _c(
                    "v-row",
                    {
                      staticStyle: { height: "600px" },
                      attrs: {
                        "no-gutters": "",
                        align: "center",
                        justify: "center",
                      },
                    },
                    [
                      _vm.loaderRender
                        ? _c(
                            "v-col",
                            {
                              staticClass: "py-0 px-4 ma-0",
                              attrs: { cols: "12" },
                            },
                            [
                              _c("v-skeleton-loader", {
                                staticClass: "rounded-0 pa-0",
                                attrs: { type: "table" },
                              }),
                            ],
                            1
                          )
                        : !_vm.renderUrl
                        ? _c(
                            "v-col",
                            [
                              _c("v-empty-state", {
                                staticClass: "mt-4",
                                attrs: {
                                  title: "PDF no disponible",
                                  customClass: "mt-6",
                                  height: 100,
                                  type: "pdf",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.loaderRender && _vm.renderUrl,
                        expression: "!loaderRender && renderUrl",
                      },
                    ],
                    attrs: { id: "render" },
                  }),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", disabled: _vm.index === 0 },
                      on: {
                        click: function ($event) {
                          _vm.index > 0 ? _vm.handlePDF("previous") : ""
                        },
                      },
                    },
                    [_vm._v("Anterior")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        outlined: "",
                        disabled:
                          _vm.index ===
                            (_vm.instance.random_preview || []).length - 1 ||
                          !_vm.renderUrl,
                      },
                      on: {
                        click: function ($event) {
                          _vm.index >= 0 &&
                          _vm.index < _vm.instance.random_preview.length - 1
                            ? _vm.handlePDF()
                            : ""
                        },
                      },
                    },
                    [_vm._v("Siguiente")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey-900", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogRandomReviewPDF = false
                        },
                      },
                    },
                    [_vm._v("Aceptar")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _vm.dialogDetail
        ? _c("DocumentRowDetail", {
            attrs: { item: _vm.instance },
            on: {
              close: function ($event) {
                _vm.dialogDetail = false
              },
            },
          })
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "650",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogDelete,
            callback: function ($$v) {
              _vm.dialogDelete = $$v
            },
            expression: "dialogDelete",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "transparent", flat: "", height: "46" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [_vm._v("Interrumpir proceso")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      ;(_vm.dialogDelete = false),
                                        (_vm.confirm = "")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-4 px-5 grey-500--text" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-2 pb-2", attrs: { align: "center" } },
                    [
                      _c("v-col", { attrs: { cols: "3" } }, [
                        _c("img", {
                          attrs: {
                            src: require(`@/assets/backgrounds/modal-document-confirm.svg`),
                            height: 128,
                          },
                        }),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "pr-3 pl-1" },
                        [
                          _c("span", { staticClass: "d-block text-body-1" }, [
                            _vm._v(
                              "Recuerde, que está confirmación permite Interrumpir el proceso y no podrá volver atrás."
                            ),
                          ]),
                          _c(
                            "span",
                            { staticClass: "d-block text-body-1 mt-4 mb-3" },
                            [
                              _vm._v("Escribe "),
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("“confirmar”"),
                              ]),
                              _vm._v(" para continuar."),
                            ]
                          ),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              "single-line": "",
                              maxlength: "9",
                              dense: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.confirm,
                              callback: function ($$v) {
                                _vm.confirm = $$v
                              },
                              expression: "confirm",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          ;(_vm.dialogDelete = false), (_vm.confirm = "")
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        disabled: _vm.confirm.toLowerCase() !== "confirmar",
                      },
                      on: { click: _vm.destroy },
                    },
                    [_vm._v("Confirmar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            scrollable: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.modalRender,
            callback: function ($$v) {
              _vm.modalRender = $$v
            },
            expression: "modalRender",
          },
        },
        [
          _c("render-pdf", {
            key: _vm.resetPDF,
            attrs: {
              basicRender: true,
              documentType: _vm._f("nameDocumentsType")(_vm.current.type),
              number: _vm.current.number,
              loaderRender: _vm.loaderRender,
              renderUrl: _vm.renderUrl,
            },
            on: {
              close: function ($event) {
                _vm.modalRender = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }